import { AxiosResponse } from 'axios';

export const isNotFoundResponse = (response?: AxiosResponse) => {
  return response ? response.status === 404 : false;
};
